import { render, staticRenderFns } from "./DefaultStep.vue?vue&type=template&id=0df7e30b&"
import script from "./DefaultStep.vue?vue&type=script&lang=ts&"
export * from "./DefaultStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports